import { useEffect, useMemo, useCallback } from "react";
import { Icon } from "@blueprintjs/core";

// Hooks
import { useAuth } from "../../auth/auth";

const WEBSITE_TOKEN = process.env.REACT_APP_CHAT_WEBSITE_TOKEN;
const BASE_URL = process.env.REACT_APP_CHAT_BASE_URL;

const ChatWidget = () => {

    const auth = useAuth();
    const { userEmail, userFullName, userClientName, userType, features } = auth;

    const allowUsers = useMemo(() => userType === "admin" || features?.indexOf("chat") >= 0, [userType, features]);

    const user = useMemo(() => ({
        identifier: userEmail,
        name: userFullName,
        email: userEmail,
        company_name: userClientName
    }), [userEmail, userFullName, userClientName]);

    useEffect(() => {
        if (user && allowUsers) {
            // Chatwoot settings
            window.chatwootSettings = {
                hideMessageBubble: true,
                position: "right",
                locale: "es",
                useBrowserLanguage: true,
                type: "standard",
                darkMode: false,
            };

            // Load Chatwoot SDK
            (function(d, t) {
                let g = d.createElement(t),
                    s = d.getElementsByTagName(t)[0];
                g.src = BASE_URL + "/packs/js/sdk.js";
                g.defer = true;
                g.async = true;
                s.parentNode.insertBefore(g, s);
                g.onload = function() {
                    window.chatwootSDK.run({
                        websiteToken: WEBSITE_TOKEN,
                        baseUrl: BASE_URL,
                    });

                    // Set user info
                    window.$chatwoot.setUser(user.identifier, {
                        name: user.name,
                        email: user.email,
                        company_name: user.company_name
                    });
                };
            })(document, "script");
        }
    }, [user, userEmail, allowUsers]);

    const handleOpenChat = useCallback(() => {
        window?.$chatwoot?.toggle(!window?.$chatwoot?.isOpen ? "open" : "close");
    }, []);

    if (!allowUsers) return null;

    return (
        <div
            style={{
                color: "white",
                height: 36,
                width: 36,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                marginRight: 36,
            }}
        >
            <Icon icon="chat" iconSize={24} style={{cursor: "pointer"}} onClick={() => handleOpenChat()} />
        </div>
    );
};

export default ChatWidget;
